import React from 'react';

import { axiosInstance } from './apiUtils';
import { acquireApiAccessToken } from '../auth/msalConfig';

export const ApiRequestInterceptor = ({ children }) => {
    axiosInstance.interceptors.request.use(async (config) => {
        const accessToken = await acquireApiAccessToken();

        const bearer = `Bearer ${accessToken}`;
        config.headers.Authorization = bearer;

        return config;
    });

    return <>{children}</>;
};